import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

const LINKS = [
  ["HIPAA Notice", "/legal/hipaa"],
  ["Privacy Policy", "/legal/privacy"],
  ["Terms of Use", "/legal/terms"],
  ["Compliance", "/legal/compliance"],
  ["Accessibility", "/legal/accessibility"],
  ["Help & Knowledge Base", "/help"],
];

export function AppFooter() {
  const [meta, setMeta] = useState(null);
  useEffect(() => {
    try {
      const cached = sessionStorage.getItem("app_meta");
      if (cached) { setMeta(JSON.parse(cached)); return; }
    } catch { /* ignore */ }
    api.get("/app-meta").then((r) => {
      setMeta(r.data);
      try { sessionStorage.setItem("app_meta", JSON.stringify(r.data)); } catch { /* ignore */ }
    }).catch(() => {});
  }, []);
  return (
    <footer data-testid="app-footer" className="border-t border-[#EFEBE0] bg-[#FDFCF8] px-4 py-1.5 text-[10px] leading-tight text-[#7B6157]">
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5">
        <span data-testid="footer-copyright">© {new Date().getFullYear()} Cocoa EHR. All rights reserved.</span>
        {LINKS.map(([label, to]) => (
          <Link key={to} to={to} data-testid={`footer-link-${to.split("/").pop()}`} className="hover:text-[#3E2723] hover:underline">{label}</Link>
        ))}
        <span data-testid="footer-version" className="rounded-full bg-[#F5F2EB] px-2 py-0.5 font-semibold">v{meta?.version || "2.x"}</span>
      </div>
    </footer>
  );
}
